import { CToaster } from '@coreui/react';
import React from 'react';

const BaseToaster = React.memo(({ children, ...rest }) => {
  return <CToaster {...rest}>{children}</CToaster>;
});

export default BaseToaster;
